<template>
  <div class="mainNav" :class="{active: isActive}">
    <div class="toggleNav" @click="isActive = !isActive">
      Navigation
      <div class="bar1"></div>
      <div class="bar2"></div>
      <div class="bar3"></div>
    </div>
    <nav>
      <ul>
        <li><router-link to="/" exact>Startseite</router-link></li>
        <li v-for="scene in scenes" :key="scene.sceneId"><router-link :to="'/scene/' + scene.sceneId" exact>{{(scene.title) ? scene.title : scene.sceneId}}</router-link></li>
      </ul>
      <ul class="meta">
        <li><router-link to="/impressum" exact>Impressum</router-link></li>
        <li><router-link to="/datenschutz" exact>Datenschutzerklärung</router-link></li>
      </ul>
    </nav>
  </div>

</template>

<script>

export default {
  name: 'Header',
  props: {
    scenes: {type: Object, default: () => {} },
  },
  data () {
    return {
      isActive: false,
    }
  },
  watch: {
    // $route(to) {
    $route() {
      // console.log(to);
      // if (to.path == "/") this.isActive = false;
      this.isActive = false;
    }
  }
}
</script>
